"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //      


var _request = require("./request");

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
	function Utils() {
		_classCallCheck(this, Utils);
	}

	_createClass(Utils, null, [{
		key: "invertColor",
		value: function invertColor(hexTripletColor) {
			var color = hexTripletColor;
			color = color.substring(1); // remove #
			color = parseInt(color, 16); // convert to integer
			color = 0xFFFFFF ^ color; // invert three bytes
			color = color.toString(16); // convert to hex
			color = ("000000" + color).slice(-6); // ("000000" + color).slice(-6); // pad with leading zeros
			color = "#" + color; //"#" + color;                  // prepend #
			return color;
		}
	}, {
		key: "createSetfromGeoJSON",
		value: function createSetfromGeoJSON(features, field) {
			var _this = this;

			var fontsSet = new Set();

			features.forEach(function (feature, index) {

				var parseFont = _this.parseStringFromHtml(feature.properties[field]);

				if (feature.properties[field] !== null) fontsSet.add(parseFont);
			});

			return Array.from(fontsSet);
		}
	}, {
		key: "getDateFromTimestamp",
		value: function getDateFromTimestamp(timestamp) {

			var date = new Date(timestamp);
			var h = this.addZero(date.getHours());
			var m = this.addZero(date.getMinutes());
			var s = this.addZero(date.getSeconds());
			var month = this.addZero(date.getMonth() + 1);
			var year = date.getFullYear().toString();
			var dia = date.getDate();

			return dia + "/" + month + "/" + year + " " + h + ":" + m + ":" + s;
		}
	}, {
		key: "addZero",
		value: function addZero(i) {
			if (i < 10) {
				i = "0" + i;
			}
			return i;
		}
	}, {
		key: "getFileObjectContent",
		value: function getFileObjectContent(url, filename) {

			return new Promise(function (resolve) {

				_request2.default.get(url + "/" + filename).then(function (res) {
					return resolve(res);
				}).catch(function () {
					return resolve("");
				});
			});
		}
	}, {
		key: "cleanHtmlAccentsString",
		value: function cleanHtmlAccentsString(str) {

			return str.replace("&egrave;", "è").replace("&agrave;", "à").replace("&ograve;", "ò");
		}
	}]);

	return Utils;
}();

Utils.removeItem = function (items, i) {
	return items.slice(0, i - 1).concat(items.slice(i, items.length));
};

Utils.parseStringFromHtml = function (htmlString) {
	return new DOMParser().parseFromString(htmlString, "text/html").body.textContent;
};

module.exports = Utils;
